<template>
  <v-container id="left-timeline" width="100%" fluid class="theme-back">
    <v-card outlined class="v-card-rounded theme-background theme-highborder">
      <v-tabs class="event-title theme-background theme-highborder" hide-slider fixed-tabs>
        <v-tab class="event-title-tab theme-highborder" ripple disabled></v-tab>
        <v-tab class="event-title-tab theme-highborder theme-title" ripple @click="filter = 'allEvent'"
               :class="{active: filter === 'allEvent'}">
          Összes esemény <span class="font-weight-bold pl-1">{{ items.length }}</span>
        </v-tab>
        <v-tab class="event-title-tab theme-highborder theme-title" ripple @click="filter = 'rejectedEvents'"
               :class="{active: filter === 'rejectedEvents'}">
          Javítandó események <span class="font-weight-bold pl-1">{{ countRejected }}</span>
        </v-tab>
        <v-tab class="event-title-tab theme-highborder theme-title" ripple @click="filter = 'draftEvents'"
               :class="{active: filter === 'draftEvents'}">
          Vázlat <span class="font-weight-bold pl-1">{{ countDrafts }}</span>
        </v-tab>
        <v-tab class="event-title-tab theme-highborder theme-title" ripple @click="toggleTimeline">
          Bezárás
          <v-icon class="theme-title ml-1 mr-2" style="font-size: 24px;">mdi-chevron-down</v-icon>
        </v-tab>
      </v-tabs>

      <!-- JAVÍTÁS (MEMÓRIA/CPU, 77. tétel): a lista a ReportScreen-en v-show-val
           rejtve MINDIG ki volt rajzolva - egy teljes meccs végére ~5 600 DOM-elem,
           és minden mentésnél az egész újrarajzolódott, akkor is, ha az idővonal
           be volt csukva. A komponens (és az adatfeldolgozása, eseménykezelői)
           továbbra is él, csak a sorokat rajzoljuk ki kizárólag nyitott
           idővonalnál. -->
      <template v-if="isVisible">
      <v-timeline small align-top dense v-if="filteredList.length" :disabled="gamefinished">
        <v-timeline-item right fill-dot small v-for="item in filteredList" :key="item.id" :disabled="gamefinished">
          <template v-slot:opposite :disabled="gamefinished">
            <span class="subtitle-1 time-title font-weight-bold align-start">{{ item.gameTime }}</span>
            <span class="subtitle-3 period-title align-start">{{ item.periodName }}</span>
            <span v-if="item.isDraft" class="subtitle-3 draft align-center">Vázlat</span>
          </template>

          <v-row width="100%" class="theme-back"
                 :class="{'timeline-body-row-dashed draftEvent' : item.isDraft, 'timeline-body-row': !item.isDraft, 'theme-red-border row-reason': !item.approved && item.rejectReason, 'theme-green-border': item.approved, 'row-message theme-highborder': item.message && !item.rejectReason }"
                 :data-reason="getReasonLabel(item)">
            <v-col cols="2" :class="item.isDraft ? 'col-class-dashed draftEvent' : 'col-class-normal'"
                   class="theme-highborder font-weight-bold d-inline-flex align-center pl-3" :disabled="gamefinished">
              {{ item.score && item.score.teamA ? item.score.teamA : 0 }} -
              {{ item.score && item.score.teamB ? item.score.teamB : 0 }}
            </v-col>

            <v-col cols="2" :class="item.isDraft ? 'col-class-dashed draftEvent' : 'col-class-normal'"
                   class="theme-highborder font-weight-bold d-inline-flex align-center fix-line-height">
              <v-card tile flat class="d-inline-block transparent">
                <div class="subtitle-player-name"><b class="pr-1">{{ item.actionName }}</b></div>
                <div class="subtitle-player-team d-flex" v-show="item.actionType">
                  {{ localConstants.ACTIONS.ACTION_MAPPING[item.actionType] }}
                </div>
              </v-card>
            </v-col>

            <v-col :class="item.isDraft ? 'col-class-dashed draftEvent' : 'col-class-normal'" :disabled="gamefinished"
                   class="theme-highborder d-flex flex-nowrap overflow-hidden align-center">
              <v-card tile flat class="d-inline-block transparent"
                      style="min-width: calc(50% - 20px); max-width: calc(50% - 20px);">
                <div class="subtitle-player-name"><b class="pr-1">{{ item.jersey }}</b> {{ item.playerName }}</div>
                <div class="subtitle-player-team d-flex">{{ item.teamName }}</div>
              </v-card>
              <v-card v-if="item.showOtherTeamGoalKeeper" tile flat class="d-inline-block transparent placeholder">
                <v-icon style="font-size: 40px; height: 30px;">mdi-chevron-right</v-icon>
              </v-card>
              <v-card v-if="item.showOtherTeamGoalKeeper" tile flat class="d-inline-block transparent ml-1"
                      style="min-width: calc(50% - 20px); max-width: calc(50% - 20px);">
                <div class="subtitle-player-name"
                     v-if="item.otherTeamGoalKeeper !== undefined && item.otherTeamGoalKeeper !== null"><b class="pr-1">{{
                    item.otherTeamGoalKeeper.jersey
                  }}</b> {{ item.otherTeamGoalKeeper.name }}
                </div>
                <div class="subtitle-player-name" v-else>Üres</div>
                <div class="subtitle-player-team d-flex">{{ item.otherTeamName }}</div>
              </v-card>
            </v-col>
            <v-col v-if="item.modifiable && item.actionName !== 'Piros lap (auto)'" cols="1"
                   class="column-button theme-highborder pa-0 d-inline-flex align-center justify-center"
                   @click="modifyItem(item.id)" :disabled="gamefinished" :class="item.isDraft ? 'draftEvent' : ''">
              <v-icon class="theme-title" :disabled="gamefinished">mdi-pencil</v-icon>
            </v-col>

            <v-col v-if="item.actionId === 'dmr-timeOut'" cols="1"
                   class="column-button theme-highborder pa-0 d-inline-flex align-center justify-center"
                   @click="acceptTimeout(item)" :disabled="gamefinished || !acceptableTimeouts.includes(item.id)"
                   :class="item.isDraft ? 'draftEvent' : ''">
              <v-icon class="theme-title" :disabled="gamefinished || !acceptableTimeouts.includes(item.id)">mdi-check
              </v-icon>
            </v-col>

            <v-col v-if="item.deletable" cols="1"
                   class="column-button theme-highborder pa-0 d-inline-flex align-center justify-center"
                   @click="deleteItem(item.id)" :disabled="gamefinished" :class="item.isDraft ? 'draftEvent' : ''">
              <v-icon class="theme-title" :disabled="gamefinished">mdi-trash-can-outline</v-icon>
            </v-col>
          </v-row>
        </v-timeline-item>
      </v-timeline>
      <v-card v-else tile flat class="d-flex align-center justify-center theme-background theme-text"
              style="font-size: 14px;" height="100px">
        Nincsenek események
      </v-card>
      </template>
    </v-card>
  </v-container>
</template>

<script>
import eventBus from '@/eventBus';
import CONSTANTS from '@/constants';
import Bugsnag from "@bugsnag/js";

export default {
  name: "TimelineList",
  props: {
    index: Number,
    draft: Boolean,
    items: Array,
    gamedata: Object,
    period: String,
    periodItems: Array,
    gamefinished: Boolean
  },
  data() {
    return {
      filter: 'allEvent',
      timelineItems: [],
      rejectReasons: CONSTANTS.DMR.REJECT_REASONS,
      //ezeket az eventeket nem lehet módosítani, csak törölni
      nonModifiableItems: [
        "dmr-timeOut",
        "timeOut"
      ],
      acceptableTimeouts: [],
      localConstants: CONSTANTS
    }
  },
  methods: {
    toggleTimeline() {
      eventBus.$emit(CONSTANTS.ACTIONS.TOGGLE.TIMELINE);
    },
    initTimeLineData(timelineData) {
      let self = this;
      this.timelineItems = [];
      let showOtherTeamGoalKeeperActions = ['gol', 'gol2p', 'vedett', 'gol7m', 'vedett7m', 'gol6m', 'vedett6m'];

      // --- JAVÍTÁS: Segédfüggvény a biztonságos listázáshoz ---
      const getList = (list) => Array.isArray(list) ? list : [];
      // -------------------------------------------------------

      timelineData.forEach(function (obj) {
        let player = null;
        let teamName = null;
        let otherTeamGoalKeeper = null;
        let otherTeamName = null;

        // JAVÍTÁS: Minden .find() hívás előtt védelmet (getList) használunk
        if (obj.params.selectedTeamId === 'teamA') {
          player = getList(self.gamedata.team_a_players).find(playerObj => playerObj.id === obj.params.selectedPlayer);
          teamName = self.gamedata.team_a_name;
          otherTeamName = self.gamedata.team_b_name;
          otherTeamGoalKeeper = obj.params && obj.params.otherTeamGoalKeeper ? getList(self.gamedata.team_b_players).find(playerObj => playerObj.id === obj.params.otherTeamGoalKeeper.id) : null;
        } else if (obj.params.selectedTeamId === 'teamB') {
          player = getList(self.gamedata.team_b_players).find(playerObj => playerObj.id === obj.params.selectedPlayer);
          teamName = self.gamedata.team_b_name;
          otherTeamName = self.gamedata.team_a_name;
          otherTeamGoalKeeper = obj.params && obj.params.otherTeamGoalKeeper ? getList(self.gamedata.team_a_players).find(playerObj => playerObj.id === obj.params.otherTeamGoalKeeper.id) : null;
        } else if (obj.params.selectedTeamId === 'staffA') {
          player = getList(self.gamedata.team_a_officials).find(playerObj => playerObj.id === obj.params.selectedPlayer);
          teamName = self.gamedata.team_a_name;
          otherTeamName = self.gamedata.team_b_name;
          otherTeamGoalKeeper = obj.params && obj.params.otherTeamGoalKeeper ? getList(self.gamedata.team_b_players).find(playerObj => playerObj.id === obj.params.otherTeamGoalKeeper.id) : null;
        } else if (obj.params.selectedTeamId === 'staffB') {
          player = getList(self.gamedata.team_b_officials).find(playerObj => playerObj.id === obj.params.selectedPlayer);
          teamName = self.gamedata.team_b_name;
          otherTeamName = self.gamedata.team_a_name;
          otherTeamGoalKeeper = obj.params && obj.params.otherTeamGoalKeeper ? getList(self.gamedata.team_a_players).find(playerObj => playerObj.id === obj.params.otherTeamGoalKeeper.id) : null;
        }

        let scoreA = (obj.params && obj.params.teamScore) ? obj.params.teamScore.teamA : undefined;
        let scoreB = (obj.params && obj.params.teamScore) ? obj.params.teamScore.teamB : undefined;

        let showOtherTeamGoalKeeper = false;
        let period = self.periodItems.find(item => item.value === obj.period);
        if (period === undefined) {
          period = self.periodItems.find(item => item.value == obj.period);
        }
        let periodName = period ? period.text : '-';

        // JAVÍTÁS: a DMR törlése a `deleted` mezőt boolean `true`-ként írja
        // (l. dbmanager.js remove()), a CR törlése viszont numerikus `1`-ként
        // (l. TimelineList.vue deleteItem) - ez a szűrő korábban csak az `1`-et
        // ismerte fel, ezért egy DMR-törölt esemény (pl. tévesen rögzített gól)
        // itt, a CR saját jegyzőkönyv-listájában TOVÁBBRA IS megjelent,
        // annak ellenére hogy a DMR már törölte - ez okozta a "plusz gól,
        // ami nem törölhető" tünetet. A kódbázis más részein (pl. game.js
        // reCalculateScores, loadGameData smart merge) már mindkét formátumot
        // helyesen kezeli, itt eddig hiányzott ugyanez a védelem.
        if (obj.deleted !== 1 && obj.deleted !== true) {
          if (obj.action !== 'timeOut' || (obj.action === 'timeOut' && obj.params.type !== 'lost')) {
            let actionId = obj.params.selectedAction ? obj.params.selectedAction.actionId : null;
            let modifiable = !self.nonModifiableItems.includes(actionId); //ha nincs közte, módosítható
            let deletable = true;

            showOtherTeamGoalKeeper = showOtherTeamGoalKeeperActions.includes(actionId);

            if (obj.action === 'dmr-timeOut') {
              eventBus.$emit(CONSTANTS.EVENTS.REFRESH_TIMEOUT, {
                UUID: obj.id,
                teamId: obj.params.selectedTeam,
                period: obj.period,
                gameTime: obj.gametime
              });
            }

            self.timelineItems.push({
              id: obj.id,
              jersey: player ? player.jersey : null,
              playerName: player ? player.name : null,
              gametime: obj.gametime,
              gameTime: obj.params ? obj.params.gameTime : null,
              action: obj.action,
              actionName: obj.params.selectedAction ? obj.params.selectedAction.actionName : null,
              actionType: obj.params && obj.params.selectedActionType ? obj.params.selectedActionType : null,
              isDraft: obj.isDraft,
              clientTime: obj.clientTime || 0,
              date: obj.date || 0,
              approved: obj.params.approved,
              rejectReason: obj.params.rejectReason,
              message: obj.params.message,
              teamName: teamName,
              actionId: actionId,
              teamId: obj.params.selectedTeam,
              modifiable: modifiable,
              deletable: deletable,
              score: {
                "teamA": scoreA,
                "teamB": scoreB,
              },
              otherTeamGoalKeeper: otherTeamGoalKeeper,
              otherTeamName: otherTeamName,
              showOtherTeamGoalKeeper: showOtherTeamGoalKeeper,
              period: obj.period,
              periodName: periodName,
              totalGameTime: obj.totalGameTime,
            });
          }
        }
      });

      // JAVÍTÁS (TELJESÍTMÉNY): l. a game.js updateSortedTimeline azonos
      // javítását - a modul-feloldás és az `isStrand` kiszámítása kikerült a
      // komparátorból, így nem összehasonlításonként kétszer fut le.
      const isStrand = this.$store.state.game.gamedata && this.$store.state.game.gamedata.rule === 'STRAND';
      const getChronoOrder = require('@/utils/periodOrder').getChronoOrder;

      this.timelineItems.sort((a, b) => {
        const pA = getChronoOrder(a.period, isStrand);
        const pB = getChronoOrder(b.period, isStrand);

        if (pA < pB) {
          return 1;
        } else if (pA === pB) {
          if (a.gameTime < b.gameTime) {
            return 1;
          }
          if (a.gameTime === b.gameTime && (a.date || a.clientTime || 0) < (b.date || b.clientTime || 0)) {
            return 1;
          }
        }
        return -1;
      });
    },
    getReasonLabel(item) {
      let reason = '';

      if (item.rejectReason) {
        reason = this.rejectReasons[item.rejectReason];
      }

      if (item.message) {
        reason = reason != '' ? `${reason} - ${item.message}` : item.message;
      }

      return reason;
    },
    acceptTimeout(item) {
      let self = this;

      let savedItem = {
        UUID: item.id,
        teamId: item.teamId,
        period: item.period,
        gametime: item.gametime,
        gameTime: item.gameTime,
        totalGameTime: item.totalGameTime,
      }

      self.deleteItem(item.id);

      eventBus.$emit(CONSTANTS.EVENTS.ACCEPT_TIMEOUT, savedItem);
    },
    modifyItem(id) {
      let self = this;

      window.dbmanager.read(id).then(function (record) {

        // --- JAVÍTÁS: A Store-ból kérjük le a timeline-t, nem a gamedata-ból ---
        let timelineData = self.$store.state.game.timelineData || [];
        // ----------------------------------------------------------------------

        // Megnézzük, hogy létezik-e az elem a memóriában is
        let timeLineRecordIndex = timelineData.findIndex(timelineRec => timelineRec.id === record.UUID);

        if (timeLineRecordIndex !== -1) {
          eventBus.$emit(CONSTANTS.EVENTS.MODIFYITEMDATA, record);
          self.toggleTimeline();
        } else {
          console.warn("Hiba: A szerkesztendő elem nem található a Store-ban.", record.UUID);
          // Opcionális: Ha a DB-ben megvan, de a Store-ban nincs,
          // akkor is megengedhetjük a szerkesztést (biztonsági tartalék):
          eventBus.$emit(CONSTANTS.EVENTS.MODIFYITEMDATA, record);
          self.toggleTimeline();
        }
      });
    },
    deleteItem(id) {
      if (this.gamefinished) {
        return;
      }
      let self = this;

      // DB olvasás
      window.dbmanager.read(id).then(function (record) {
        // JAVÍTÁS (4515a - Bugsnag-logolás bővítése): olcsó breadcrumb minden
        // törlésnél (nem önálló hibajelentés, csak kontextus egy KÉSŐBBI
        // hibához) - a "plusz gól, ami nem törölhető" esethez hasonló jövőbeli
        // problémáknál ez azonnal megmutatja mikor, ki (CR/DMR), milyen
        // action-t és UUID-t próbált törölni, mongo dump bekérése nélkül is.
        Bugsnag.leaveBreadcrumb('Event delete requested', {
          UUID: record.UUID,
          action: record.action,
          period: record.period,
          usertype: window.usertype
        });

        // Törölt státusz beállítása
        record.deleted = 1;

        // DMR / Draft logika (Eredeti kód megtartása)
        if (CONSTANTS.DMR.DMR_DRAFTS.includes(record.action) && record.action !== 'dmr-timeOut') {
          record.action = CONSTANTS.DMR.DRAFTS_TO_EVENT[record.action] ?? record.action;
          if (record.params && record.params.selectedAction) {
            record.params.selectedAction.actionId = record.action;
          }
        }

        // DB Update
        window.dbmanager.update(record, false).then(function () {

          // --- JAVÍTOTT RÉSZ: VUEX STORE FRISSÍTÉS ---
          if (!record.id && record.UUID) {
            record.id = record.UUID;
          }

          // 1. A Store-ban is bejelöljük töröltnek az elemet
          self.$store.commit('game/UPDATE_TIMELINE_EVENT', record);

          // 2. Újraszámoljuk az eredményeket és frissítjük a listát (fontos!)
          self.$store.dispatch('game/reCalculateScores');

          // 3. Újraszámoljuk az időkéréseket is (hogy a pöttyök frissüljenek)
          self.$store.dispatch('game/recalculateTimeOuts');

          // ------------------------------------------

          // Legacy események (Lapok/Kiállítások visszavonása)
          let extraEmit = {
            'keklap': CONSTANTS.ACTIONS.CARDS.TAKE.BLUE,
            'piroslap': CONSTANTS.ACTIONS.CARDS.TAKE.RED,
            'sargalap': CONSTANTS.ACTIONS.CARDS.TAKE.YELLOW,
            'kiallitas': CONSTANTS.ACTIONS.CARDS.TAKE.STRAND_YELLOW,
            '2perc': CONSTANTS.ACTIONS.PENALTIES.TAKE,
            '4perc': CONSTANTS.ACTIONS.PENALTIES.TAKE,
          };

          if (Object.keys(extraEmit).includes(record.action)) {
            eventBus.$emit(extraEmit[record.action], record);
          }

          // Screen mode check (Eredeti kód megtartása)
          let actualEventNumbers = 0;
          window.dbmanager.readAll().then((data) => {
            if (data.length) {
              data.forEach(function (item) {
                if (!item.deleted && item.action !== "gamedatachange" && item.action !== "init") {
                  actualEventNumbers++;
                }
              });
            }
            eventBus.$emit(CONSTANTS.EVENTS.CHANGE.SCREENMODE, actualEventNumbers <= 0);
          });

          eventBus.$emit(CONSTANTS.EVENTS.RECORD.DELETED, record);
        });
        return false;
      });
    },
  },
  computed: {
    // A ReportScreen ugyanezzel az állapottal (v-show) mutatja/rejti az idővonalat.
    isVisible() {
      return this.$store.state.ui.showTimeLine;
    },
    countDrafts() {
      let drafts = this.timelineItems.filter(c => c.isDraft);
      return drafts.length;
    },
    countRejected() {
      let rejectedItems = this.timelineItems.filter(c => !c.approved && c.rejectReason);
      return rejectedItems.length;
    },
    filteredList() {
      return this[this.filter];
    },
    draftEvents() {
      return this.timelineItems.filter(item => {
        return item.isDraft;
      })
    },
    rejectedEvents() {
      return this.timelineItems.filter(item => {
        return !item.approved && item.rejectReason;
      })
    },
    allEvent() {
      return this.timelineItems;
    }
  },
  created: function () {
    let self = this;

    // Ha kívülről akar valaki törölni valamit
    this._recordDeleteHandler = (UUID) => self.deleteItem(UUID);
    eventBus.$on(CONSTANTS.EVENTS.RECORD.DELETE, this._recordDeleteHandler);

    this._acceptableTimeoutHandler = function (data) {
      if (self.acceptableTimeouts.includes(data.UUID)) {
        if (!data.timeout) {
          self.acceptableTimeouts = self.acceptableTimeouts.filter(function (item) {
            return item !== data.UUID
          })
        }
      } else {
        if (data.timeout) {
          self.acceptableTimeouts.push(data.UUID);
        }
      }
    };
    eventBus.$on(CONSTANTS.EVENTS.ACCEPTABLE_TIMEOUT_UUID, this._acceptableTimeoutHandler);

    this.initTimeLineData(this.items);
  },
  beforeDestroy() {
    if (this._recordDeleteHandler) eventBus.$off(CONSTANTS.EVENTS.RECORD.DELETE, this._recordDeleteHandler);
    if (this._acceptableTimeoutHandler) eventBus.$off(CONSTANTS.EVENTS.ACCEPTABLE_TIMEOUT_UUID, this._acceptableTimeoutHandler);
  },
  watch: {
    items: function (timelineData) {
      this.initTimeLineData(timelineData);
    },
  }
}
</script>

<style scoped>
.col {
  padding: 6px !important;
}

.fix-line-height {
  line-height: 16px;
  overflow: hidden;
  font-stretch: condensed;
  font-family: 'Roboto Condensed';
}

.theme-red-border > .col {
  border-color: #F73051 !important;
}

.theme-green-border > .col {
  border-color: #4caf50 !important;
}

.row-reason {
  position: relative;
}

.row-message:after,
.row-reason:after {
  content: attr(data-reason);
  border-top: 0 !important;
  padding: 0 6px;
  display: flex;
  flex-flow: row;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: 26px;
  line-height: 26px;
  width: 100%;
  font-size: 14px;
  font-stretch: condensed;
  font-family: 'Roboto Condensed';
}

.row-reason:after {
  border: 1px solid #F73051;
}

.theme--dark .row-message:after {
  border: 1px dashed #4d5269;
}

.theme--light .row-message:after {
  border: 1px dashed #dddddd;
}
</style>

<style>
.event-title {
  border-bottom-width: 1px;
  border-bottom-style: solid;
}

.event-title-tab {
  font-size: 14px;
  text-transform: none !important;
  font-weight: normal !important;
  letter-spacing: normal !important;
  padding: 6px !important;
  width: auto !important;
}

.theme--light .event-title-tab.active {
  background-color: #d3e4d3;
}

.theme--dark .event-title-tab.active {
  background-color: #40434f;
}

.event-title-tab:not(:last-child) {
  border-right-width: 1px;
  border-right-style: solid;
}

.event-title-tab:last-child {
  justify-content: flex-end;
}

.column-button {
  border-top-width: 1px;
  border-top-style: solid;
  border-left-width: 1px;
  border-left-style: solid;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  cursor: pointer;
  text-align: center;
}

.column-button:nth-last-child(1) {
  border-right: 1px solid #000000;
}

.column-button > .v-icon {
  font-size: 18px;
}

.time-title {
  display: block;
  line-height: 0.75rem !important;
}

.period-title {
  display: block;
  margin-top: 3px;
  padding-left: 6px;
  font-size: 11px;
  white-space: nowrap;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
}

.draft {
  font-size: 11px;
  padding-right: 4px;
}

.subtitle-player-name {
  font-size: 14px;
  font-stretch: condensed;
  font-family: 'Roboto Condensed';
  line-height: 16px;
  margin-bottom: 2px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.subtitle-player-team {
  font-size: 10px;
  font-stretch: condensed;
  font-family: 'Roboto Condensed';
  font-style: italic;
  line-height: 12px;
}

.subtitle-player-team, .subtitle-player-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.col-class-normal {
  border-top-width: 1px;
  border-top-style: solid;
  border-bottom-width: 1px;
  border-bottom-style: solid;
}

.col-class-normal:nth-child(1) {
  border-left-width: 1px;
  border-left-style: solid;
}

.col-class-normal:nth-last-child(1) {
  border-right-width: 1px;
  border-right-style: solid;
}

.col-class-dashed {
  border-top-width: 1px;
  border-top-style: dashed;
  border-bottom-width: 1px;
  border-bottom-style: dashed;
}

.col-class-dashed:nth-child(1) {
  border-left-width: 1px;
  border-left-style: dashed;
}

.col-class-dashed:nth-last-child(1) {
  border-right-width: 1px;
  border-right-style: dashed;
}

.timeline-body-row, .timeline-body-row-dashed {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  margin-right: 15px !important;
  margin-left: 0 !important;
  margin-top: 4px !important;
}

.theme--light .timeline-body-row:before, .theme--light .timeline-body-row-dashed:before {
  border-color: #dddddd;
}

.theme--light .timeline-body-row-dashed:before {
  border-color: #dddddd;
}

.theme--dark .timeline-body-row:before, .theme--dark .timeline-body-row-dashed:before {
  border-color: #4d5269;
}

.theme--dark .timeline-body-row-dashed:before {
  border-color: #4d5269;
}

.timeline-body-row:before, .timeline-body-row-dashed:before {
  content: "";
  position: absolute;
  left: -20px;
  width: 20px;
  border-top-width: 1px;
  border-top-style: solid;
}

.timeline-body-row-dashed:before {
  border-top-width: 1px;
  border-top-style: solid;
}

#left-timeline {
  padding: 16px 16px 0 16px !important;
}

#left-timeline .v-card-rounded {
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;

  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;

  border-width: 1px !important;
  border-style: solid !important;
}

#left-timeline .v-timeline-item__dot.v-timeline-item__dot--small {
  height: 10px !important;
  width: 10px !important;
  margin-right: 2px;
  box-shadow: none;
}

#left-timeline .theme--light.v-timeline:before {
  background-image: linear-gradient(black 33%, rgba(255, 255, 255, 0) 0%) !important;
}

#left-timeline .theme--dark.v-timeline:before {
  background-image: linear-gradient(white 33%, rgba(255, 255, 255, 0) 0%) !important;
}

#left-timeline .v-timeline:before {
  background-position: right !important;
  background-repeat: repeat-y !important;
  background-size: 2px 8px !important;
  left: calc(10% + 2px) !important;
  top: 36px;
  height: calc(100% - 60px);
  background: none;
}

#left-timeline .v-timeline-item__divider {
  max-width: 5% !important;
  min-width: 5% !important;
}

#left-timeline .v-timeline--dense .v-timeline-item__opposite {
  display: inline-block !important;
  max-width: 8% !important;
  min-width: 8% !important;
  align-self: baseline;
  text-align: right;
}

#left-timeline .v-timeline--dense .v-timeline-item__body {
  display: inline-block !important;
  max-width: 87% !important;
  min-width: 87% !important;
}

#left-timeline .theme--dark.v-tabs > .v-tabs-bar {
  background-color: transparent !important;
}

.draftEvent {
  background-color: #40434f !important;
  border-color: #40434f !important;
}
</style>
